import { Stack, Typography } from "@mui/material";

export default function BoxItem({ label, textRight, textLeft }) {
  return (
    <Stack
      sx={{
        background: "#EFF5F7",
        padding: "16px",
        gap: "16px",
        border: "1px solid #1E729F",
        borderRadius: "5px",
        height: "100%",
      }}
    >
      <Typography
        component="p"
        className="item-text color-blue-dark"
        fontWeight="500"
        fontSize="18px"
        sx={{
          fontWeight: "500 !important",
          fontSize: "18px !important",
        }}
      >
        {label}
      </Typography>
      <Stack gap="16px" display="grid" gridTemplateColumns="1fr 1fr">
        <Stack>
          <Typography component="p" className="item-text label">
            Direita
          </Typography>
          <Typography component="p" className="item-text color-gray">
            {textRight}
          </Typography>
        </Stack>
        <Stack>
          <Typography component="p" className="item-text label">
            Esquerda
          </Typography>
          <Typography component="p" className="item-text color-gray">
            {textLeft}
          </Typography>
        </Stack>
      </Stack>
    </Stack>
  );
}
